import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  en: {
    "nav.features": "Features",
    "nav.how": "How It Works",
    "nav.pricing": "Pricing",
    "nav.calculator": "ROAS Calculator",
    "nav.login": "Log In",
    "nav.trial": "Start Free Trial",
    "hero.badge": "Built for Malaysia SMEs & Digital Agencies · RM Supported",
    "hero.title1": "Stop Optimizing Ads For Clicks.",
    "hero.title2": "Start Optimizing For Revenue.",
    "hero.sub": "One AI platform to create, launch, track and optimize Meta & Google advertising — from campaign to lead, sale, revenue and profit.",
    "hero.from": "Starting from RM149 / month",
    "hero.cta1": "Start 14-Day Free Trial",
    "hero.cta2": "Book a Demo",
    "diff.title": "The Big Difference",
    "diff.ordinary": "Ordinary dashboards see:",
    "diff.us": "AdsBoster sees:",
    "diff.tagline": "Optimize For Business Results — Not Clicks.",
    "customers.title": "Built For Every Growth Business",
    "customers.sub": "AdsBoster AI fits businesses that live and die by real sales — not vanity clicks.",
    "features.title": "One Platform. Full Funnel.",
    "features.sub": "Everything from AI campaign creation to revenue attribution and profit optimization.",
    "calc.title": "Revenue ROAS Calculator",
    "calc.sub": "See what full-funnel optimization does to your numbers.",
    "calc.spend": "Monthly Ad Spend (RM)",
    "calc.roas": "Target ROAS",
    "calc.revenue": "Projected Revenue",
    "calc.profit": "Est. Profit Contribution",
    "pricing.title": "Simple, Transparent Pricing",
    "pricing.sub": "Ringgit Malaysia. No hidden fees. Actual ad spend is billed separately by the platforms.",
    "pricing.month": "/month",
    "pricing.popular": "MOST POPULAR",
    "pricing.choose": "Choose Plan",
    "pricing.trial": "Start Free Trial",
    "pricing.annual": "Pay 10 Months, Get 12 — save with annual billing.",
    "bundle.title": "Coming Soon: The Growth Bundle",
    "bundle.sub": "AdsBoster + AI Chat + CRM in one price. See the full journey: Ad → WhatsApp → Lead → Salesperson → Sale → Revenue.",
    "final.title": "Turn Advertising Spend Into Measurable Business Growth.",
    "final.flow": "CREATE → PUBLISH → TRACK → CONVERT → ATTRIBUTE → OPTIMIZE → GROW",
    "final.cta": "Start Your 14-Day Trial",
    "login.title": "Welcome to AdsBoster AI",
    "login.sub": "Sign in to access your revenue command centre.",
    "login.google": "Continue with Google",
    "login.secure": "Secure sign-in · 14-day free trial · No credit card",
    // dashboard
    "dash.overview": "Command Centre",
    "dash.builder": "AI Campaign Builder",
    "dash.copywriter": "AI Copywriter",
    "dash.leads": "Lead Centre",
    "dash.crm": "CRM Pipeline",
    "dash.attribution": "Revenue Attribution",
    "dash.doctor": "Campaign Doctor",
    "dash.brief": "Daily CEO Brief",
    "dash.alerts": "Alert Centre",
    "dash.tracking": "Tracking Health",
    "dash.compliance": "Compliance Checker",
    "dash.logout": "Log Out",
    "dash.customers": "Customers",
    "dash.integrations": "Connect Meta Ads",
    "dash.competitors": "Competitors",
    "dash.optimize": "AI Optimization",
    "dash.switchAdmin": "Switch to Admin",
    "dash.switchOwner": "Switch to Owner",
    "dash.viewingAs": "Viewing",
    "dash.readOnly": "read-only",
    "dash.exitView": "Exit customer view",
    "common.language": "BM",
  },
  bm: {
    "nav.features": "Ciri",
    "nav.how": "Cara Ia Berfungsi",
    "nav.pricing": "Harga",
    "nav.calculator": "Kalkulator ROAS",
    "nav.login": "Log Masuk",
    "nav.trial": "Mula Percubaan Percuma",
    "hero.badge": "Dibina untuk SME & Agensi Digital Malaysia · Sokongan RM",
    "hero.title1": "Berhenti Optimum Iklan Untuk Klik.",
    "hero.title2": "Mula Optimum Untuk Revenue.",
    "hero.sub": "Satu platform AI untuk mencipta, melancarkan, memantau dan mengoptimumkan iklan Meta & Google — dari kempen ke lead, jualan, revenue dan keuntungan.",
    "hero.from": "Bermula dari RM149 / bulan",
    "hero.cta1": "Mula Percubaan 14 Hari",
    "hero.cta2": "Tempah Demo",
    "diff.title": "Perbezaan Besar",
    "diff.ordinary": "Dashboard biasa lihat:",
    "diff.us": "AdsBoster lihat:",
    "diff.tagline": "Optimum Untuk Hasil Perniagaan — Bukan Klik.",
    "customers.title": "Dibina Untuk Setiap Perniagaan Berkembang",
    "customers.sub": "AdsBoster AI sesuai untuk perniagaan yang bergantung pada jualan sebenar — bukan klik kosong.",
    "features.title": "Satu Platform. Seluruh Funnel.",
    "features.sub": "Dari penciptaan kempen AI hingga revenue attribution dan optimum keuntungan.",
    "calc.title": "Kalkulator Revenue ROAS",
    "calc.sub": "Lihat kesan optimum full-funnel pada angka anda.",
    "calc.spend": "Perbelanjaan Iklan Bulanan (RM)",
    "calc.roas": "Sasaran ROAS",
    "calc.revenue": "Unjuran Revenue",
    "calc.profit": "Anggaran Sumbangan Untung",
    "pricing.title": "Harga Mudah & Telus",
    "pricing.sub": "Ringgit Malaysia. Tiada caj tersembunyi. Perbelanjaan iklan sebenar dicaj berasingan oleh platform.",
    "pricing.month": "/bulan",
    "pricing.popular": "PALING POPULAR",
    "pricing.choose": "Pilih Pelan",
    "pricing.trial": "Mula Percubaan Percuma",
    "pricing.annual": "Bayar 10 Bulan, Dapat 12 — jimat dengan bil tahunan.",
    "bundle.title": "Akan Datang: Bundle Pertumbuhan",
    "bundle.sub": "AdsBoster + AI Chat + CRM dalam satu harga. Lihat perjalanan penuh: Iklan → WhatsApp → Lead → Salesperson → Jualan → Revenue.",
    "final.title": "Tukar Perbelanjaan Iklan Kepada Pertumbuhan Perniagaan Yang Boleh Diukur.",
    "final.flow": "CIPTA → LANCAR → JEJAK → TUKAR → ATRIBUT → OPTIMUM → BERKEMBANG",
    "final.cta": "Mula Percubaan 14 Hari",
    "login.title": "Selamat Datang ke AdsBoster AI",
    "login.sub": "Log masuk untuk akses pusat kawalan revenue anda.",
    "login.google": "Teruskan dengan Google",
    "login.secure": "Log masuk selamat · Percubaan 14 hari · Tanpa kad kredit",
    "dash.overview": "Pusat Kawalan",
    "dash.builder": "Pembina Kempen AI",
    "dash.copywriter": "Penulis Iklan AI",
    "dash.leads": "Pusat Lead",
    "dash.crm": "Pipeline CRM",
    "dash.attribution": "Atribusi Revenue",
    "dash.doctor": "Doktor Kempen",
    "dash.brief": "Taklimat CEO Harian",
    "dash.alerts": "Pusat Amaran",
    "dash.tracking": "Kesihatan Tracking",
    "dash.compliance": "Pemeriksa Pematuhan",
    "dash.logout": "Log Keluar",
    "dash.customers": "Pelanggan",
    "dash.integrations": "Sambung Meta Ads",
    "dash.competitors": "Pesaing",
    "dash.optimize": "Optimum AI",
    "dash.switchAdmin": "Tukar ke Admin",
    "dash.switchOwner": "Tukar ke Owner",
    "dash.viewingAs": "Melihat",
    "dash.readOnly": "baca-sahaja",
    "dash.exitView": "Keluar paparan pelanggan",
    "common.language": "EN",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "bm" : "en")), []);
  return <I18nContext.Provider value={{ lang, t, toggle, setLang }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
